module.exports = __webpack_public_path__ + "static/media/Tile Image 2.378da787.png";